var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"need-container"},[_c('Header',{attrs:{"cityValue":_vm.cityValue},on:{"changeCity":_vm.handleChangeCity}}),_vm._t("default"),_c('Footer'),_c('right-nav')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }